module.exports = __webpack_public_path__ + "static/img/ps1.3daeea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/ps1.png
// module id = Pnal
// module chunks = 53